import { filterGroups, sortOptions } from '@/mocks/categories';

export interface FilterState {
  type: string;
  region: string;
  year: string;
}

interface FilterPanelProps {
  filters: FilterState;
  onChange: (key: keyof FilterState, value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  onReset: () => void;
}

export default function FilterPanel({
  filters,
  onChange,
  sort,
  onSortChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-base font-bold text-foreground-900">筛选条件</h3>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium text-foreground-500 transition-colors hover:bg-background-100 hover:text-primary-600"
        >
          <i className="ri-refresh-line" />
          重置
        </button>
      </div>

      {filterGroups.map((group) => (
        <div key={group.key} className="border-t border-background-200/70 pt-5">
          <h4 className="mb-3 text-sm font-medium text-foreground-600">{group.label}</h4>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = filters[group.key] === option;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => onChange(group.key, option)}
                  className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                    active
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-600'
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      <div className="border-t border-background-200/70 pt-5">
        <h4 className="mb-3 text-sm font-medium text-foreground-600">排序方式</h4>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((option) => {
            const active = sort === option.key;
            return (
              <button
                key={option.key}
                type="button"
                onClick={() => onSortChange(option.key)}
                className={`flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                  active
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-100 text-foreground-500 hover:bg-secondary-100 hover:text-secondary-700'
                }`}
              >
                <i className="ri-sort-desc" />
                {option.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}